/**
 * Predator Identifier Page
 *
 * "What Killed My Animal?" tool for Bridge Club members.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import BridgeClubLayout from '../../components/BridgeClub/BridgeClubLayout';
import PredatorIdentifier from '../../components/BridgeClub/PredatorIdentifier';

const PredatorIdentifierPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <BridgeClubLayout>
      <PredatorIdentifier
        onClose={() => navigate('/bridge-club/resources')}
      />
    </BridgeClubLayout>
  );
};

export default PredatorIdentifierPage;
